<ng-container #formDirective="parent-form" thr-parent-form>
    <div class="row">
        <div class="col-12 col-sm-6">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <mat-label>{{ 'form.social-name' | translate }}</mat-label>
                <input name="fdolpName" matInput [placeholder]="'form.hints.social-name' | translate" [disabled]="true" [(ngModel)]="client.name" />
            </mat-form-field>
        </div>
        <div class="col-12 col-sm-6">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <mat-select name="fdolpCountry" [placeholder]="'form.country-social' | translate" [disabled]="true" [(ngModel)]="client.country">
                    <mat-option *ngFor="let country of countries" [value]="country.id.value">
                        {{ country.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="col-12 col-sm-6">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <mat-select name="fdolpDocumentType" [placeholder]="'form.document' | translate" [disabled]="true" [(ngModel)]="client.docType">
                    <ng-template ngFor let-type [ngForOf]="client.allowedDocTypes">
                        <mat-option [value]="type">{{ 'form.document-types.' + type | translate }}</mat-option>
                    </ng-template>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-12 col-sm-6">
            <ng-container [ngSwitch]="client.docType">
                <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.CIF">
                    <mat-label>{{ 'form.document-types.CI' | translate }}</mat-label>
                    <input name="fdolpDocument" matInput [placeholder]="'form.hints.cif' | translate" [disabled]="true" [(ngModel)]="client.docId" />
                </mat-form-field>
                <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchDefault>
                    <input name="fdolpDocument" matInput [placeholder]="'form.document-types.TR' | translate" [disabled]="true" [(ngModel)]="client.docId" />
                </mat-form-field>
            </ng-container>
        </div>

        <div class="col-12 col-md-6">
            <mat-checkbox name="fdolpNotPhone" [disabled]="isDisabled" [(ngModel)]="client.phoneExonerate" *ngIf="!isClientPortal">
                {{ 'form.not-phone' | translate }}
            </mat-checkbox>
            <div class="row">
                <div class="col-12 col-sm-6 col-md-12">
                    <mat-form-field class="full-width mb-3 mb-sm-4">
                        <input name="fdolpPhone" matInput [placeholder]="'form.phone' | translate" required minlength="9" pattern="[\d\+]+" [phoneExists]="true" [clientCode]="client.encryptedCode" [disabled]="client.phoneExonerate || isDisabled" [(ngModel)]="client.phone" #phoneCtrl="ngModel"
                        />
                        <mat-error *ngIf="(phoneCtrl.hasError('minlength') || phoneCtrl.hasError('pattern')) && !phoneCtrl.hasError('required')">
                            {{ 'form.validation.invalid.phone' | translate }}
                        </mat-error>
                        <mat-error *ngIf="phoneCtrl.hasError('phoneExists') && !phoneCtrl.hasError('required')">
                            {{ 'form.validation.phone-exists' | translate }}
                        </mat-error>
                        <mat-error *ngIf="phoneCtrl.hasError('required')">
                            {{ 'form.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-12 col-sm-6 col-md-12">
                    <mat-form-field class="full-width mb-3 mb-sm-4">
                        <input name="fdolpPhoneConfirm" matInput [placeholder]="'form.phone-confirm' | translate" required minlength="9" pattern="[\d\+]+" [equalTo]="phoneCtrl" [disabled]="client.phoneExonerate || isDisabled" [(ngModel)]="client.phoneConfirm" #phoneConfirmCtrl="ngModel"
                        />
                        <mat-error *ngIf="
                                (phoneConfirmCtrl.hasError('minlength') || phoneConfirmCtrl.hasError('pattern')) &&
                                !phoneConfirmCtrl.hasError('required')
                            ">
                            {{ 'form.validation.invalid.phone' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                phoneConfirmCtrl.hasError('equalTo') &&
                                !phoneConfirmCtrl.hasError('minlength') &&
                                !phoneConfirmCtrl.hasError('pattern') &&
                                !phoneConfirmCtrl.hasError('required')
                            ">
                            {{ 'form.validation.equalTo.phone' | translate }}
                        </mat-error>
                        <mat-error *ngIf="phoneConfirmCtrl.hasError('required')">
                            {{ 'form.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6">
            <mat-checkbox name="fdolpNotEmail" [disabled]="isDisabled" [(ngModel)]="client.emailExonerate" *ngIf="!isClientPortal">
                {{ 'form.not-email' | translate }}
            </mat-checkbox>
            <div class="row">
                <div class="col-12 col-sm-6 col-md-12">
                    <mat-form-field class="full-width mb-3 mb-sm-4">
                        <input name="fdolpEmail" matInput [placeholder]="'form.email' | translate" required emailWithDot [emailExists]="true" [clientCode]="client.encryptedCode" [disabled]="client.emailExonerate || isDisabled" [(ngModel)]="client.email" #emailCtrl="ngModel"
                        />
                        <mat-error *ngIf="emailCtrl.hasError('email') && !emailCtrl.hasError('required')">
                            {{ 'form.validation.invalid.email' | translate }}
                        </mat-error>
                        <mat-error *ngIf="emailCtrl.hasError('emailExists') && !emailCtrl.hasError('required')">
                            {{ 'form.validation.email-exists' | translate }}
                        </mat-error>
                        <mat-error *ngIf="emailCtrl.hasError('required')">
                            {{ 'form.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-12 col-sm-6 col-md-12">
                    <mat-form-field class="full-width mb-3 mb-sm-4">
                        <input name="fdolpEmailConfirm" matInput [placeholder]="'form.email-confirm' | translate" required emailWithDot [equalTo]="emailCtrl" [disabled]="client.emailExonerate || isDisabled" [(ngModel)]="client.emailConfirm" #emailConfirmCtrl="ngModel" />
                        <mat-error *ngIf="emailConfirmCtrl.hasError('email') && !emailConfirmCtrl.hasError('required')">
                            {{ 'form.validation.invalid.email' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                emailConfirmCtrl.hasError('equalTo') &&
                                !emailConfirmCtrl.hasError('email') &&
                                !emailConfirmCtrl.hasError('required')
                            ">
                            {{ 'form.validation.equalTo.email' | translate }}
                        </mat-error>
                        <mat-error *ngIf="emailConfirmCtrl.hasError('required')">
                            {{ 'form.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="col-12 col-sm-6">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <mat-label>{{ 'form.legalEntityID' | translate }}</mat-label>
                <input name="plplegalEntityId" matInput [placeholder]="'form.hints.legalEntityId' | translate" [disabled]="false || isValidator || isDisabled" [(ngModel)]="client.legalEntityId" />
            </mat-form-field>
        </div>

        <div class="col-12 col-sm-6">
            <!-- TODO: BUG with required dynamic in child form component https://github.com/angular/angular/issues/23657 -->
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <mat-label>{{ 'form.expired-document-date.LEI' | translate }}</mat-label>
                <input name="pnpLegalEntityIdExpiration" matInput [min]="today" [matDatepicker]="legalEntityIdExpirationPicker" maxlength="10" [disabled]="client.disabled || isValidator || isDisabled" [placeholder]="'form.hints.date' | translate" [(ngModel)]="client.legalEntityIdExpirationDate"
                    #legalEntityIdExpirationCtrl="ngModel" />
                <mat-datepicker-toggle matSuffix [for]="legalEntityIdExpirationPicker"></mat-datepicker-toggle>
                <mat-datepicker #legalEntityIdExpirationPicker [disabled]="isDisabled || isDisabledSubmit"></mat-datepicker>
                <mat-error *ngIf="!legalEntityIdExpirationCtrl.valid">
                    {{ 'form.validation.expired-lei-date' | translate }}
                </mat-error>
            </mat-form-field>
        </div>

        <div class="col-12 col-sm-6">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <input name="fdolpLandLine" matInput [placeholder]="'form.telephone' | translate" minlength="9" pattern="[\d\+]+" [disabled]="isDisabled" [(ngModel)]="client.landLine" #landLineCtrl="ngModel" />
                <mat-error *ngIf="(landLineCtrl.hasError('minlength') || landLineCtrl.hasError('pattern')) && !landLineCtrl.hasError('required')">
                    {{ 'form.validation.invalid.phone' | translate }}
                </mat-error>
                <mat-error *ngIf="landLineCtrl.hasError('required')">
                    {{ 'form.validation.required' | translate }}
                </mat-error>
            </mat-form-field>
        </div>

        <div class="col-12 col-sm-6">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <mat-label>{{ 'form.constitution-date' | translate }}</mat-label>
                <input name="companyConstitutionDate" matInput [max]="today" [matDatepicker]="companyConstitutionDatePicker" required maxlength="10" [disabled]="client.disabled || isValidator || isDisabled" [placeholder]="'form.hints.date' | translate" [(ngModel)]="client.companyConstitutionDate" #companyConstitutionDateCtrl="ngModel"
                />
                <mat-datepicker-toggle matSuffix [for]="companyConstitutionDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #companyConstitutionDatePicker [disabled]="isDisabled || isDisabledSubmit"></mat-datepicker>
                <mat-error *ngIf="!companyConstitutionDateCtrl.valid">
                    {{ 'form.validation.date' | translate }}
                </mat-error>
            </mat-form-field>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <h3 class="mat-subheading-1 text-blue font-weight-bold mb-0">
                {{ 'full-data.tax-residence' | translate }}
            </h3>
            <mat-hint class="d-block mat-caption font-italic mb-3">{{ 'full-data.has-to-match-identification-address' | translate }}
            </mat-hint>
        </div>
        <div class="col-12">
            <thr-full-data-form-address [isDisabled]="isDisabled" [address]="client.legalResidence" (change)="onLegalResidenceChange()"></thr-full-data-form-address>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                {{ 'full-data.mail-residence-legal-question' | translate }}
            </h3>
            <mat-radio-group name="fdonpYesNo" [(ngModel)]="client.isEqualMailAddress" (ngModelChange)="onEqualMailAddressChange()" [required]="true" [disabled]="isDisabled">
                <div class="row">
                    <div class="col-6 col-sm-3">
                        <mat-radio-button name="fdonpNo" class="mb-3 mb-sm-4" color="blue-gray" [value]="false">
                            {{ 'general.no' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-6 col-sm-3">
                        <mat-radio-button name="fdonpYes" class="mb-3 mb-sm-4" color="blue-gray" [value]="true">
                            {{ 'general.yes' | translate }}
                        </mat-radio-button>
                    </div>
                </div>
            </mat-radio-group>
        </div>
        <div class="col-12" *ngIf="!client.isEqualMailAddress">
            <thr-full-data-form-address [isDisabled]="isDisabled" [address]="client.mailResidence"></thr-full-data-form-address>
        </div>
    </div>

    <div class="row">
        <div class="col-12" [class.mt-4]="client.isEqualMailAddress">
            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                {{ 'full-data.professional-legal-data' | translate }}
            </h3>
        </div>
        <div class="col-12">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <mat-select name="fdolpActivityCode" [placeholder]="'form.activity-code' | translate" required [disabled]="isDisabled" [(ngModel)]="client.activityCode">
                    <mat-option *ngFor="let activity of activities" [value]="activity.id.value">
                        {{ activity.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <h3 class="mat-subheading-1 text-blue font-weight-bold">{{ 'full-data.activity-age' | translate }}:</h3>
            <mat-radio-group name="fdolpActivityAge" [(ngModel)]="client.activityAge" [required]="true" [disabled]="isDisabled">
                <div class="row">
                    <div class="col-12 col-sm-6 col-lg-3">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpLess1" color="blue-gray" [value]="ActivityAge.LESS_1_YEAR">
                            {{ 'form.contractual-time.less-1' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-3">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpBetween15" color="blue-gray" [value]="ActivityAge.BETWEEN_1_5_YEARS">
                            {{ 'form.contractual-time.between-1-5' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-3">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpBetween510" color="blue-gray" [value]="ActivityAge.BETWEEN_5_10_YEARS">
                            {{ 'form.contractual-time.between-5-10' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-3">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdtnpMore10" color="blue-gray" [value]="ActivityAge.MORE_10_YEARS">
                            {{ 'form.contractual-time.more-10' | translate }}
                        </mat-radio-button>
                    </div>
                </div>
            </mat-radio-group>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <h3 class="mat-subheading-1 text-blue font-weight-bold">{{ 'full-data.legal-source-of-income' | translate }}:</h3>
            <mat-radio-group name="fdolpSourceIncome" [(ngModel)]="client.sourceOfIncome" (ngModelChange)="onResize()" [required]="true" [disabled]="isDisabled">
                <div class="row">
                    <div class="col-12 col-sm-6 col-lg-4">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdolpActivity" color="blue-gray" [value]="LegalSourceIncome.ACTIVITY">
                            {{ 'form.legal-source-income.activity' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdolpSale" color="blue-gray" [value]="LegalSourceIncome.SALE">
                            {{ 'form.legal-source-income.sale' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdolpOther" color="blue-gray" [value]="LegalSourceIncome.OTHER">
                            {{ 'form.legal-source-income.other' | translate }}
                        </mat-radio-button>
                    </div>
                </div>
            </mat-radio-group>
            <mat-form-field class="full-width mb-3 mb-sm-4" *ngIf="client.sourceOfIncome === LegalSourceIncome.OTHER">
                <input name="fdolpSourceIncomeOther" matInput [placeholder]="'form.other-source-income' | translate" required [disabled]="isDisabled" [(ngModel)]="client.sourceOfIncomeFreeText" #sourceOfIncomeFreeText="ngModel" />
                <mat-error *ngIf="sourceOfIncomeFreeText.hasError('required')">
                    {{ 'form.validation.required' | translate }}
                </mat-error>
            </mat-form-field>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <h3 class="mat-subheading-1 text-blue font-weight-bold">{{ 'full-data.volume' | translate }}:</h3>
            <mat-radio-group name="fdolpVolume" [(ngModel)]="client.volume" [required]="true" [disabled]="isDisabled">
                <div class="row">
                    <div class="col-12 col-sm-6 col-lg-4">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdolpLess500000" color="blue-gray" [value]="Volume.LESS_500000">
                            {{ 'form.volume.less-500000' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdolpBetween5000011000000" color="blue-gray" [value]="Volume.BETWEEN_500001_1000000">
                            {{ 'form.volume.between-500001-1000000' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdolpBetween100000110000000" color="blue-gray" [value]="Volume.BETWEEN_1000001_10000000">
                            {{ 'form.volume.between-1000001-10000000' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-4">
                        <mat-radio-button class="mb-3 mb-sm-4" name="fdolpMore10000000" color="blue-gray" [value]="Volume.MORE_10000000">
                            {{ 'form.volume.more-10000000' | translate }}
                        </mat-radio-button>
                    </div>
                </div>
            </mat-radio-group>
        </div>
    </div>

    <div class="row justify-content-end" *ngIf="!isDisabled">
        <div class="col-12 col-sm-6 col-md-4">
            <button type="submit" class="full-width mat-elevation-z0" mat-raised-button color="blue">
                {{ 'general.save'|translate }}
            </button>
        </div>
    </div>
</ng-container>
